import {InvitationAgentAndRepsResponseType} from '@/features/representative/types'
import clientAPIV3 from '@/clientAPIV3'
import {InvitationAgentType} from '../types'
import {RepresentativeTypeV3, UserV3} from '@/features/authentication/types'

export const sendAgentInvitationV3 = async (dataToSend: InvitationAgentType): Promise<InvitationAgentType> => {
    const {data} = await clientAPIV3.post('/creators/agents', dataToSend)
    return data
}

export const agentAcceptRequestV3 = async (token: string) => {
    const {data} = await clientAPIV3.get(`/rookies/agents/requests/accept/${token}`)
    return data
}

export const verifyAgentInvitationTokenV3 = async (token: string): Promise<InvitationAgentAndRepsResponseType> => {
    const {data} = await clientAPIV3.get(`/agents/invitations/verify/${token}`)
    return data
}

export const getAgentHostsV3 = async (): Promise<Partial<UserV3>[]> => {
    const {data} = await clientAPIV3.get('/agents/creators')
    return data
}

export const getAgentRepresentativesV3 = async (): Promise<RepresentativeTypeV3[]> => {
    const {data} = await clientAPIV3.get('/agents/representatives')
    return data
}

export const deleteAgentV3 = async (id: string) => {
    const {data} = await clientAPIV3.delete(`/creators/agents/${id}`)
    return data
}

export const getModesV3 = async (): Promise<{id: number; keyName: string}[]> => {
    const {data} = await clientAPIV3.get('/modes')
    return data
}
